import React from "react";
import { createPortal } from "react-dom";

interface Props {
  id?: string;
  selector?: string;
  element?: React.ReactElement;
  children?: React.ReactNode;
  target?: Element;
}

export const Portal = ({ id, element, children, selector, target }: Props) => {
  const el =
    target || document.getElementById(id) || document.querySelector(selector);

  return createPortal(element || children, el);
};
